<template>
  <!-- CTA/연락처 섹션 편집 드로어 -->
  <a-drawer
    :visible="isVisible"
    title="CTA 섹션 편집"
    placement="right"
    :width="drawerWidth"
    :destroy-on-close="false"
    @close="handleClose"
  >
    <div v-if="ctaData" class="cta-editor">
      <!-- 헤딩 -->
      <div class="cta-editor__field">
        <label class="cta-editor__label">헤딩</label>
        <a-input
          :value="ctaData.heading"
          placeholder="CTA 헤딩 텍스트"
          @change="(e) => updateField('heading', e.target.value)"
        />
      </div>

      <!-- 서브헤딩 -->
      <div class="cta-editor__field">
        <label class="cta-editor__label">서브헤딩</label>
        <a-input
          :value="ctaData.subheading"
          placeholder="CTA 서브헤딩 텍스트"
          @change="(e) => updateField('subheading', e.target.value)"
        />
      </div>

      <!-- CTA 버튼 텍스트 -->
      <div class="cta-editor__field">
        <label class="cta-editor__label">버튼 텍스트</label>
        <a-input
          :value="ctaData.ctaText"
          placeholder="버튼에 표시할 텍스트"
          @change="(e) => updateField('ctaText', e.target.value)"
        />
      </div>

      <!-- 배경 색상 -->
      <div class="cta-editor__field">
        <label class="cta-editor__label">배경 색상</label>
        <div class="cta-editor__color-row">
          <input
            type="color"
            :value="ctaData.backgroundColor || '#ffffff'"
            class="cta-editor__color-input"
            @change="(e) => updateField('backgroundColor', e.target.value)"
          />
          <span class="cta-editor__color-value">
            {{ ctaData.backgroundColor || '#ffffff' }}
          </span>
        </div>
      </div>

      <!-- 폼 이메일 수신 주소 -->
      <div class="cta-editor__field">
        <label class="cta-editor__label">폼 이메일 수신 주소</label>
        <a-input
          :value="ctaData.formEmail"
          type="email"
          placeholder="contact@example.com"
          @change="(e) => updateField('formEmail', e.target.value)"
        />
        <!-- 이메일 형식 오류 메시지 -->
        <span v-if="emailError" class="cta-editor__error">올바른 이메일 형식을 입력하세요.</span>
      </div>
    </div>

    <!-- 데이터 미로드 상태 -->
    <div v-else class="cta-editor__empty">
      <a-spin tip="데이터를 불러오는 중..." />
    </div>
  </a-drawer>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

// 이메일 형식 정규식
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: 'CTAEditor',

  data() {
    return {
      escHandler: null,
      emailError: false,
    };
  },

  computed: {
    ...mapState('homepageEditor', ['activeEditor']),
    ...mapGetters('homepageEditor', ['currentPageData']),

    isVisible() {
      return (
        this.activeEditor?.type === 'drawer' &&
        this.activeEditor?.sectionKey === 'cta'
      );
    },

    drawerWidth() {
      return window.innerWidth >= 1440 ? 520 : 420;
    },

    ctaSection() {
      if (!this.currentPageData?.sections) return null;
      return this.currentPageData.sections.find((s) => s.sectionKey === 'cta');
    },

    ctaData() {
      return this.ctaSection?.data || null;
    },
  },

  watch: {
    isVisible(val) {
      if (val) {
        this.emailError = false;
        this.registerEscHandler();
      } else {
        this.removeEscHandler();
      }
    },
  },

  beforeUnmount() {
    this.removeEscHandler();
  },

  methods: {
    handleClose() {
      this.$store.commit('homepageEditor/SET_ACTIVE_EDITOR', null);
    },

    // 섹션 데이터 필드 업데이트 (이메일은 형식 검사 포함)
    updateField(field, value) {
      if (!this.ctaSection) return;

      // 이메일 필드 유효성 검사
      if (field === 'formEmail') {
        this.emailError = value.length > 0 && !EMAIL_REGEX.test(value);
      }

      const updatedData = { ...this.ctaData, [field]: value };
      this.$store.commit('homepageEditor/UPDATE_SECTION', {
        page: 'main',
        sectionKey: 'cta',
        data: updatedData,
      });
    },

    registerEscHandler() {
      this.escHandler = (e) => {
        if (e.key === 'Escape') this.handleClose();
      };
      window.addEventListener('keydown', this.escHandler);
    },

    removeEscHandler() {
      if (this.escHandler) {
        window.removeEventListener('keydown', this.escHandler);
        this.escHandler = null;
      }
    },
  },
};
</script>

<style scoped>
.cta-editor__field {
  margin-bottom: 20px;
}

.cta-editor__label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #333;
}

.cta-editor__color-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cta-editor__color-input {
  width: 44px;
  height: 34px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  padding: 2px;
}

.cta-editor__color-value {
  font-size: 13px;
  color: #666;
  font-family: monospace;
}

.cta-editor__error {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #ff4d4f;
}

.cta-editor__empty {
  text-align: center;
  padding: 40px 0;
}
</style>
